import { Component, Inject, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  FormGroup,
} from '@angular/forms';
import { AppConfig } from '../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import {
  Session,
  NotificationType,
  Notification,
} from '../../common/entity/entities';
import { BrowserStorage } from '../../common/utils/tools';
import { SecurityHelper } from './helper/security.helper';
import { SecurityClient } from '../../client/security.client';
import { BaseLoginComponent } from './baseLogin.component';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { ServiceStatusMessageTypes } from '../../common/entity/enum/serviceStatusMessages';
import { RecaptchaComponent } from 'ng-recaptcha';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { NotificationClient } from 'src/app/client/notification.client';
import { BroadcastService } from 'src/app/common/client/broadcast.service';


@Component({
  selector: 'brinker-login',
  templateUrl: './brinkerLogin.component.html',
  styleUrls: ['./brinkerLogin.component.css'],
  providers: [
    //SecurityService, LocalizationService,
    AppConfig,
    UntypedFormBuilder,
    SecurityClient,
    //, Session, VisualTreeBuilder
  ],
})
export class BrinkerLoginComponent extends BaseLoginComponent implements OnDestroy {
  SITE_KEY = '6LfFcCksAAAAAJATFMgjUw5IcTbdde5CMNobUWgR';
  showDialog: boolean = false;
  showForgotPassDialog: boolean = false;
  changePaswordModel;
  forgotPaswordFinalModel;
  dialogForm;
  agreementURl;
  ambiguousMailOrPhone:boolean = false;
  dialogHeader;
  dialogApply;
  dialogCancel;
  showSurvey;
  dialogWidth;
  forgotPassForm: FormGroup<{emailOrPhone:UntypedFormControl, username:UntypedFormControl}>;
  forgotPassFormFinal;
  forgotPassFinalVisible;
  captchaValid = false;
  confirmationDialogVisible;
  confirmationHeader;
  confirmationMessage;
  captchaToken;
  contentURL;
  loading;
  showPassword = false;
  showIdentityProvider = false;
  identityProviderForm;
  identityProviderModel;
  userAgreementDialogVisible: boolean = false;
  userAgreementDialogMessage: string = '';
  private emailOrPhoneSubscription: Subscription;

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  constructor(
    public route: ActivatedRoute,
    public config: AppConfig,
    public securityClient: SecurityClient,
    public router: Router,
    public formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    public sanitizer: DomSanitizer,
    public renderer: Renderer2,
    @Inject(DOCUMENT) public _document: Document,
    private activeRoute: ActivatedRoute,
    
  ) {
    super(
      route,
      config,
      securityClient,
      router,
      formBuilder,
      translate,
      renderer,
      _document,
    );
    BrowserStorage.useFor(this);
    this.form = formBuilder.group({
      user: this.user,
      password: this.password,
    });
    this.contentURL = this.sanitizer.bypassSecurityTrustResourceUrl(
      environment.loginIframeURL
    );
    this.activeRoute.params.subscribe((params) => {
      console.log('params', params);
    });
    this.activeRoute.queryParams.subscribe((params) => {
      if (params['error']) {
        console.log('Error: ', params['error']);
      } else if (params['reason']) {
        //possible when auth-error
        let notification: Notification = new Notification(
          'Error',
          params['reason'],
          NotificationType.Error,
          3000
        );
        Session.notifications.add(notification.id, notification);
      } else if (params['code']) this.oktaLoginHandle(params['code']);
    });
  }
  resolved(event) {
    this.captchaToken = event;
    if (!event) {
      this.captchaValid = false;
    } else {
      //this.captchaValid = false;
      //this.securityClient.captchaVerify(this.translate.instant('forgotPass.verifyingCaptcha'), event).then(resp => {
      this.captchaValid = true;
      //});
    }
  }

  /**
   * Used for PDP login.
   */


  oktaLoginHandle(oneTimeCode) {
    this.loading = true;
    this.securityClient.exchangeToken(oneTimeCode).then(
      (data) => {
        this.handleLogin(data);
      },
      (reject) => {
        this.password.setValue(null);
        this.loading = false;
      }
    );
  }

  handleLogin(data) {

    this.agreementURl = undefined;
    this.dialogForm = undefined;
    let response = data.result.body;
    this.sessionObject = data;
    Session.init(data);
    this.securityClient.reinitTokenHeader();
    if (Session.data.ShowUserAgreement) this.setAgreement();
    else if (response.ShowSurvey) this.setSurvey();
    else {
      SecurityHelper.getMenu(
        this.securityClient,
        this.router,
        this.translate.instant('login.AuthorizingUser')
      ).then((rejects) => {
        this.loading = false;
        this.progress = false;
      });
      if (environment.portalCode == 'PDP')
        SecurityHelper.getActiveServiceStatusMessage(
          this.securityClient,
          ServiceStatusMessageTypes.ServiceStatusMessage
        ).then(
          (response) => {
            if (response?.result)
              localStorage.setItem(
                `serviceStatusMessage_${Session.userCode}`,
                response.result
              );
          },
          (reject) => {}
        );
    }
  }

  private showUserAgreementDialog(message: string) {
    this.userAgreementDialogVisible = true;
    this.userAgreementDialogMessage = message;
  }

  public respondToUserAgreement(agreed: boolean) {
    this.securityClient
      .acknowledge(agreed, true)
      .then((response) => {
        console.log(response);
        this.showDialog = false;
        this.changePaswordModel = undefined;
        if (Session.data.ShowSurvey) this.setSurvey();
        else
          SecurityHelper.getMenu(
            this.securityClient,
            this.router,
            this.translate.instant('login.AuthorizingUser')
          ).then((rejects) => {
            this.progress = false;
          });
        if (environment.portalCode == 'PDP')
          SecurityHelper.getActiveServiceStatusMessage(
            this.securityClient,
            ServiceStatusMessageTypes.ServiceStatusMessage
          ).then(
            (response) => {
              if (response?.result)
                localStorage.setItem(
                  `serviceStatusMessage_${Session.userCode}`,
                  response.result
                );
            },
            (reject) => {}
          );
      })
      .catch((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.showUserAgreementDialog(error.error);
        } else {
        }
      });
  }
  public cancel() {
    this.showDialog = false;
    this.changePaswordModel = undefined;
  }

  public print() {
    window.open(this.agreementURl);
  }


  private setAgreement() {
    this.showDialog = true;
    this.dialogHeader = this.translate.instant('login.manageAgreement');
    this.dialogApply = this.translate.instant('general.agree');
    this.dialogCancel = this.translate.instant('general.print');
    this.dialogWidth = '950px';
    this.agreementURl = Session.data.AgreementURL;
  }

  private setSurvey() {
    //TEMPORARILY COMMENTED:
    //confirm("THERE ARE UNCOMPLETED SURVEYS FOR YOUR CUSTOMERS");

    SecurityHelper.getMenu(
      this.securityClient,
      this.router,
      this.translate.instant('login.AuthorizingUser')
    ).then((rejects) => {
      this.progress = false;
    });
  }
  

  oktaLogin(e) {
    e.preventDefault();
    localStorage.setItem('GratLoginURL', '/brinker');  
    this.securityClient.getIdentityProvider({ code: 'brinker' }).then((response) => {
      this.identityProviderModel = { identityProviderCode: '' };
      if (
        response != null &&
        response.result != null &&
        response.result.LoginUrl != null &&
        response.result.LoginUrl != ''
      ) {
        this.showIdentityProvider = false;
        window.location.replace(response?.result.LoginUrl);
      }
    });
  }


 
  ngOnDestroy(): void {
    if (this.emailOrPhoneSubscription) {
      this.emailOrPhoneSubscription.unsubscribe();
    }
  }
}
